import { IDictionaryValue } from './dictionary-value.interface';

/** Общий класс для хранения данных различных типов справочников */
export class DictionaryType {
  static store = new Map<string, IDictionaryValue[]>();

  constructor(public code: string, values: IDictionaryValue[]) {
    DictionaryType.store.set(code, values);
  }
}
